import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
  ArmaRestDnList, ArmaRestOrderList, ErrorLineDec, LoggedUserData, ArmaRestAnalysis, ArmaRestInfoComp, ArmaRestResultSteelListSend,
  ArmaRestContact, ContactNoId, Chantier, Formes, FavoriteShape, PrintingList, PrintingListInfoFormatData
} from './json-interface';
import {ArmaServConnection} from './info-connection';
import {CLineDec, JSSteelList} from './decorticage/info-decorticage';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {CUtilit} from './utilit';

@Injectable({ providedIn: 'root', })
export class ArmaServServerMethods {

  constructor(private mHttp: HttpClient, private mDomSanitizer: DomSanitizer) { }

  /**
   * function EchoString(Value: string): string;                                 // GET Pour tester si ArmaServ répond
   */
  public async EchoString(value: string): Promise<string> {
    return (await ArmaServConnection.aGET(this.mHttp, 'EchoString', [value])).result[0];
  }

  /**
   * function  UpdateLogin(oJSonParam : TJSonValue) : TJSonObject;               // POST : Methode pour se connecter en tant que client chantier ou utilisateur armaor
   */
  public async updateLogin(oJSParam: {'user': string, 'password': string}): Promise<{ Connected: boolean, AlreadyLogged: boolean, RightUser: LoggedUserData }> {
    return (await ArmaServConnection.aPOST(this.mHttp, 'Login', oJSParam)).result[0];
  }

  /**
   * function  SetSteelListAsSend(codeSteelList: Integer): Boolean;              // GET  : Pour modifier le statut de la commande & la passer sur le statut envoyé (signifique que du coté angular la personne a finis sa commande)
   *
   */
  public async setSteelListAsSend(analysisCode: string): Promise<ArmaRestResultSteelListSend> {
    return (await ArmaServConnection.aGET(this.mHttp, 'SetSteelListAsSend', [analysisCode])).result[0];
  }

  /**
   * function  GetNewSteelList(sSiteCode: String): TJSONObject;                  // GET  : Crée & retourne une nouvelle liste d'acier
   */
  public async getNewSteelList(siteCode: string | undefined): Promise<ArmaRestOrderList> {
    return ((await ArmaServConnection.aGET(this.mHttp, 'GetNewSteelList', [siteCode])).result[0] as ArmaRestOrderList);
  }

  /**
   * function  GetSteelList(sCodeSteelList: Integer): TJSONObject;               // GET  : Retounre une liste d'acier
   */
  public async getSteelList(codeSteelList: number): Promise<ArmaRestOrderList> {
    return (await ArmaServConnection.aGET(this.mHttp, 'GetSteelList', [codeSteelList])).result[0];
  }

  /**
   * function  UpdateSaveSteelList(val : TJSONObject) : TJSONObject;             // POST : Save une liste d'acier avec les info passé dans le body de la page
   */
  public async saveSteelList(body: JSSteelList): Promise<{
    'Result': number;
    'Errors': ErrorLineDec[];
    Exception?: string;
  }> {
    return await (await ArmaServConnection.aPOST(this.mHttp, 'SaveSteelList', body, [])).result[0];
  }

  /**
   * @deprecated On utilise maintenant toujours le treillis généré par le client web
   * function TServerMethods.UpdateGetImageMesh(Width: Integer; Height: Integer; oJsLineDec: TJSONObject): TStream;
   */
  public async getImageMesh(oLineDec: CLineDec, width: number, height: number): Promise<SafeUrl> {
    return await ArmaServConnection.aPostSafeurlImgFromDatasnap(
      this.mHttp,
      this.mDomSanitizer,
      'GetImageMesh',
      oLineDec.toJsLineDec(false),
      [width, height]
    );
  }

  /**
   * function TServerMethods.UpdateGetDrawingShape(Width: Integer; Height: Integer; oJsonLineDec: TJSONObject): TStream;
   *
   */
  public async getDrawingShape(oLineDec: CLineDec, widdh: number, height: number): Promise<SafeUrl> {
    return await ArmaServConnection.aPostSafeurlImgFromDatasnap(
      this.mHttp,
      this.mDomSanitizer,
      'GetDrawingShape',
      oLineDec.toJsLineDec(false),
      [widdh, height]
    );
  }

  public async getListDN(siteCode: string): Promise<ArmaRestDnList[]> {
    // mArmaServMethod
    // await ArmaServConnection.aGET(this.mHttp, 'GetListDN', [this.mToolbar.selectedSiteCode]);
    const dataSnapResult = await ArmaServConnection.aGET(this.mHttp, 'GetListDN', [siteCode]);
    return (dataSnapResult.result[0] as ArmaRestDnList[]);
  }

  public async downloadDN(codeDn: string, downloadFile: boolean) {
    return ArmaServConnection.getPDF(this.mHttp, 'DownloadDN', [codeDn], downloadFile, `Delivery note No ${codeDn}.pdf`);
  }

  public async downloadAllDn() {
    return ArmaServConnection.downloadFile(this.mHttp, 'DownloadAllDN', [], 'DN.zip');
  }

  public async loadListSteelList(siteCode: string = ''): Promise<ArmaRestOrderList[]> {
    const dataSnapResult = await ArmaServConnection.aGET(this.mHttp, 'LoadListSteelList', [siteCode]);
    return (dataSnapResult.result[0] as ArmaRestOrderList[]);
  }

  public async getListOrder(siteCode: string): Promise<ArmaRestAnalysis[]> {
    const dataSnapResult = await ArmaServConnection.aGET(this.mHttp, 'GetListOrder', [siteCode]);
    return (dataSnapResult.result[0] as ArmaRestAnalysis[]);
  }

  public async getListorderInfoComp(siteCode: string): Promise<ArmaRestInfoComp[]> {
    const dataSnapResult = await ArmaServConnection.aGET(this.mHttp, 'GetListOrderInfoComp', [siteCode]);
    return (dataSnapResult.result[0] as ArmaRestInfoComp[]);
  }

  public async downloadOrder(orderCode: string, downloadFile: boolean) {
    return ArmaServConnection.getPDF(this.mHttp, 'DownloadOrder', [orderCode], downloadFile, (orderCode + '.pdf'));
  }

  public async downloadAllOrder() {
    return ArmaServConnection.downloadFile(this.mHttp, 'DownloadAllOrder', [], 'Order.zip');
  }

  public async duplicateSteelList(codeSteelList: string): Promise<ArmaRestOrderList> {
    return await (await ArmaServConnection.aGET(this.mHttp, 'DuplicateSteelList', [codeSteelList])).result[0];
  }

  public async cancelSteelList(codeSteelList: string): Promise<void> {
    await ArmaServConnection.aGET(this.mHttp, 'CancelSteelList', [codeSteelList]);
  }

  public async getListContact(siteCode: string): Promise<ArmaRestContact[]> {
    return (await ArmaServConnection.aGET(this.mHttp, 'GetListContactWeb', [siteCode])).result[0];
  }

  public async getContact(id: number): Promise<ArmaRestContact> {
    return (await ArmaServConnection.aGET(this.mHttp, 'ContactWeb', [id])).result[0];
  }

  public async createContact(siteCode: string, contact: ContactNoId): Promise<ArmaRestContact> {
    return (await ArmaServConnection.aPOST(this.mHttp, 'ContactWeb', contact, [siteCode])).result[0];
  }

  public async updateContact(contactId: number, contact: ContactNoId): Promise<ArmaRestContact> {
    return (await ArmaServConnection.aPut(this.mHttp, 'ContactWeb', contact, [contactId])).result[0];
  }

  public async loadGParam(): Promise<{
    OPT_WMESH: boolean,
    FACTORY_NAME: string,
    SHAPE_99: string,
    UNIT_USED: string|'mm'|'cm'|'M',
    USE_JOINING_CODE: boolean,
    NB_MIN_MESH: number,
    INPUT_STEEL_AND_PRODUCT: boolean,
    UNIT_DIM_PLAQUE_MESH: number,
    WEB_MIN_OPEN_DATE_BETWEEN_CREATE_AND_DELIVERY: number,
  }> {
    return await (await ArmaServConnection.aGET(this.mHttp, 'LoadGParam')).result[0];
  }

  public async getListSite(): Promise<Chantier[]> {
    return (await ArmaServConnection.aGET(this.mHttp, 'GetListSite', [])).result[0];
  }

  public async loadEmptyAnalysis(siteCode: string): Promise<{
    shapeAvailable: Formes[],
    shapeFavorite: FavoriteShape[]
  }> {
    return (await ArmaServConnection.aGET(this.mHttp, 'LoadEmptyAnalysis', [siteCode])).result[0];
  }

  public async getFactoryHollydays(factoryCode: number): Promise<any> {
    return await (await ArmaServConnection.aGET(this.mHttp, 'GetHollydays', [factoryCode])).result[0];
  }

  public async getListFactory(): Promise<any> {
    return (await ArmaServConnection.aGET(this.mHttp, 'GetListFactory')).result[0];
  }

  public async getListProductFamily(): Promise<any> {
    return (await ArmaServConnection.aGET(this.mHttp, 'GetListProductFamily')).result[0];
  }

  public async getStockData(factoryCode: number, familyCode: string, steelStock: boolean): Promise<any> {
    return (await ArmaServConnection.aGET(this.mHttp, 'GetStockData', [factoryCode, familyCode, steelStock])).result[0];
  }

  public async getSQL(body: any): Promise<any> {
    return (await ArmaServConnection.aPOST(this.mHttp, 'GetSQL', body, [])).result[0];
  }

  public async getSQLAutoCompletion(body: {TableName: any, FieldName: any, LFGFieldName: any}): Promise<any> {
    return (await ArmaServConnection.aPOST(this.mHttp, 'GetAutoCompletion', body)).result[0];
  }

  /**
   * @param printingListType CST_PRINTING_LIST_TYPE_XMLFile
   * @param onlyAvailableOnWeb Retourne seulement les format coché disponible sur le web
   */
  public async getListFormat(printingListType: number, onlyAvailableOnWeb: boolean): Promise<PrintingListInfoFormatData[]> {
    return (await ArmaServConnection.aGET(this.mHttp, 'GetListFormat', [printingListType, onlyAvailableOnWeb])).result[0];
  }

  public async getListClient(): Promise<string[]> {
    return (await ArmaServConnection.aGET(this.mHttp, 'GetListClient')).result[0];
  }

  public async getSiteForCustomer(customer: string = ''): Promise<string[]> {
    return (await ArmaServConnection.aGET(this.mHttp, 'GetSiteForCustomer', [customer])).result[0];
  }

  public async getPrintingList(typePrintingList: number,
                               selectedSite: string,
                               selectedCustomer: string,
                               idFormat: number,
                               beginDate: Date,
                               endDate: Date): Promise<PrintingList> {
    return (await ArmaServConnection.aGET(this.mHttp, 'GetPrintingList',
      [
        typePrintingList,
        selectedSite,
        selectedCustomer,
        idFormat,
        CUtilit.convertDateToYYY_MM_DD(beginDate),
        CUtilit.convertDateToYYY_MM_DD(endDate)
      ])).result[0];
  }

  public async prepareAndDownloadPrintingList(fileExtension: string,
                                              typePrintingList: number,
                                              selectedSite: string,
                                              selectedCustomer: string,
                                              idFormat: number,
                                              beginDate: Date,
                                              endDate: Date) {
    const filePath = (await ArmaServConnection.aGET(this.mHttp, 'PrepareDownloadPrintingList',
      [
        fileExtension,
        typePrintingList,
        selectedSite,
        selectedCustomer,
        idFormat,
        CUtilit.convertDateToYYY_MM_DD(beginDate),
        CUtilit.convertDateToYYY_MM_DD(endDate)
      ])).result[0];
      const filename = CUtilit.getFileNameFromPath(filePath);
      await ArmaServConnection.getFile(this.mHttp, filePath, filename, true, false);
  }

  public async getRightUser(): Promise<LoggedUserData> {
    return (await ArmaServConnection.aGET(this.mHttp, 'GetRightUser')).result[0];
  }

  // TODO: Faire le reste des fonctions utilisées pour pour armaserv
}
